import { useAppSelector } from "../app/store";
import { Role } from "../types";

export default function useAuth(roles?: Role[]) {
  const { access_token, authInfo } = useAppSelector((state) => state.auth);
  const isRoleResolved = Boolean(authInfo?.role);
  const accessRole =
    authInfo?.role && roles?.length && roles?.includes(authInfo?.role);

  // Keep session alive during transient role/profile sync issues so users are
  // not redirected to sign-in while token is still valid.
  if (access_token && roles?.length && !isRoleResolved) {
    return true;
  }

  return access_token && (roles?.length ? accessRole : true);
}
